import Eye from "../assets/Eye.jsx";

const getEducationColumns = (onView) => [
    {
        title: "Title",
        dataIndex: "title",
        key: "title",
    },
    {
        title: "Description",
        dataIndex: "description",
        key: "description",
        ellipsis: true,
    },
    {
        title: "Action",
        dataIndex: "action",
        key: "action",
        width: 80,
        align: "center",
        render: (_, record) => (
            <div
                className="cursor-pointer inline-flex"
                onClick={() => onView(record)}
                title="View"
            >
                <Eye />
            </div>
        ),
    },
];

export default getEducationColumns;
